const isNearBlack = (r: number, g: number, b: number): boolean => {
	return r < 60 && g < 60 && b < 60;
};

const isNearWhite = (r: number, g: number, b: number): boolean => {
	return r > 200 && g > 200 && b > 200;
};

export const adjustColorsForDarkMode = (
	html: string,
	isDarkMode: boolean,
): string => {
	if (!isDarkMode) {
		return html;
	}

	let sanitized = html.replace(
		/color:\s*rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/gi,
		(match, r, g, b) => {
			const red = Number.parseInt(r, 10);
			const green = Number.parseInt(g, 10);
			const blue = Number.parseInt(b, 10);

			if (isNearBlack(red, green, blue) || isNearWhite(red, green, blue)) {
				return "color: inherit";
			}
			return match;
		},
	);

	sanitized = sanitized.replace(
		/color:\s*(black|#000(?:000)?)/gi,
		"color: inherit",
	);

	sanitized = sanitized.replace(
		/color:\s*(white|#fff(?:fff)?)/gi,
		"color: inherit",
	);

	return sanitized;
};
